import { Header, LogoIcon, Paragraph } from "@datagame/ui";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";

import styles from "./AuthPageLayout.module.scss";

const cx = classNames.bind(styles);

export interface AuthPageLayoutProps {
  children: ReactNode;
  imageClassName?: string;
}

export const AuthPageLayout = ({ children, imageClassName }: AuthPageLayoutProps) => {
  const { t } = useTranslation("account");

  const imageClassNames = cx("imageArea", imageClassName);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.formWrapper}>
          <div>{children}</div>
        </div>
      </div>
      <div className={imageClassNames}>
        <div className={styles.imageWrapper}>
          <div className={styles.contentWrapper}>
            <div className={styles.textWrapper}>
              <Header variant="h2" className={styles.header}>
                {t("image.header")}
              </Header>
              <Paragraph size="large" color="background">
                {t("image.description")}
              </Paragraph>
              <Paragraph color="background">{t("image.copyright")}</Paragraph>
            </div>

            <LogoIcon className={styles.logo} />
          </div>
        </div>
      </div>
    </div>
  );
};
